import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "dailyDateNavigation" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-start date-toggle-container" }
const _hoisted_3 = { class: "mx-2 font-size-sm fw-bold" }
const _hoisted_4 = { class: "calendar-no-visits-vue text-dark mt-2" }
const _hoisted_5 = {
  ref: "noVisitDatePicker",
  class: "schedule-calendar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("i", {
        class: _normalizeClass('fas fa-chevron-left cursor-pointer'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.decrementTaskDate()))
      }),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formatDate(_ctx.startDate.toString(), "ddd, DD MMM , YYYY")), 1 /* TEXT */),
      _createElementVNode("span", {
        class: "calendar-icon d-flex justify-content-center align-items-center",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleCalendar && _ctx.toggleCalendar(...args)))
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(`fas fa-calendar-alt ${_ctx.showCalendar == true ? 'active' : ''}`)
        }, null, 2 /* CLASS */)
      ]),
      _createElementVNode("i", {
        class: _normalizeClass('fas fa-chevron-right cursor-pointer ps-1'),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.incrementTaskDate()))
      })
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, null, 512 /* NEED_PATCH */)
    ], 512 /* NEED_PATCH */), [
      [_vShow, _ctx.showCalendar]
    ])
  ]))
}